import {
  Button,
  Col,
  Divider,
  Form,
  Input,
  Popover,
  Row,
  Tag,
  Tooltip,
  Typography,
  Upload,
  message,
  Select,
  DatePicker,
  Slider,
} from 'antd';
import React, { useEffect, useState } from 'react';
import { InfoCircleOutlined, UploadOutlined } from '@ant-design/icons';
import { Link, useParams } from 'react-router-dom';
import { RESTNotification, RESTSubmitform } from 'utils/RESTApi';
import { SaveFileToS3 } from 'utils/commonMethods';
import { deleteLink } from '../IdeaFunction';
import { levelColors, userStatus } from 'utils/Constants';
import '../opportunity.less';

const ItemDetailPage = ({
  setShowView,
  setCreateFile,
  handleFormLeave,
  formLayoutByGamma,
  attachment,
  setAttachMent,
  setFormChanges,
  attachedLinks,
  setAttchedLinks,
  deleteUploadedFiles,
  fileUpload,
  relatedIdea,
  listAllDepartments,
  userData,
  listRelatedIdea,
  showDrawer,
  form,
  createFile,
  fetchGammaDetails,
  setScaleValue,
  scaleValue,
}) => {
  const { TextArea } = Input;
  const { Dragger } = Upload;
  const { Paragraph } = Typography;

  const [insertLink, setInsertLink] = useState('');
  const [loader, setLoader] = useState(false);

  const [date, setDate] = useState();

  const handleChangeDate = (value) => {
    const dateString = value ? value.format('YYYY-MM-DD') : '';
    setDate(dateString);
  };

  // for upload filetoS3
  const uploadFileToS3 = async (file) => {
    return await SaveFileToS3(file);
  };

  const { id } = useParams();
  const props = {
    name: 'file',
    accept:
      // eslint-disable-next-line max-len
      'image/*, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/msword, application/vnd.ms-excel, application/vnd.ms-powerpoint, text/plain, application/pdf, application/vnd.google-apps.spreadsheet',
    multiple: true,
    onChange(info) {
      if (info.fileList?.length >= 5) {
        message.error('You can only upload up to 5 files!');
      } else {
        setCreateFile(info.fileList);
      }
    },
    async beforeUpload(file) {
      return false;
    },
  };

  const deleteAttachLinks = async (el, index) => {
    if (index >= 0 && index < attachedLinks.length) {
      // The item is in the attachedLinks array
      const updatedAttachedLinks = [...attachedLinks];
      updatedAttachedLinks.splice(index, 1);
      setAttchedLinks(updatedAttachedLinks);
    } else if (
      index >= attachedLinks.length &&
      index < attachedLinks.length + attachment.length
    ) {
      // The item is in the attachment array
      const updatedAttachment = [...attachment];
      const attachmentIndex = index - attachedLinks.length;
      updatedAttachment.splice(attachmentIndex, 1);
      setAttachMent(updatedAttachment);
    }
  };

  const unLinkIdeas = async (id) => {
    try {
      await deleteLink(id);
      message.success('Items unlink successfully');
      await listRelatedIdea();
    } catch (error) {
      console.log(error);
    }
  };
  const updateFormItems = async () => {
    setLoader(true);
    let formValue = form.getFieldsValue();
    const uploadPromises = [];
    formLayoutByGamma?.layout?.forEach(async (item) => {
      if (item?.dropdownValue === 'Multiple') {
        if (item?.optionType === 'Custom') {
          if (formValue[item?.id] !== undefined) {
            item['newValue'] = formValue?.[item?.id].map((item) => item);
          } else {
            item['newValue'] = []; // Set it to an empty array when formValue[item?.id] is undefined
          }
        } else if (item?.label === 'Department') {
          const oldID = item?.value?.items.map((item) => item?.departmentId);
          let removedID = item?.value?.items?.filter(
            (e) => !formValue[item?.id]?.includes(e?.departmentId)
          );
          item['newValue'] = formValue?.[item?.id];
        } else if (item?.label === 'Contributors') {
          const oldID = item?.value?.items.map((item) => item?.id);
          const oldUserID = item?.value?.items.map((item) => item?.userId);
          let removedID = item?.value?.items?.filter(
            (e) => !formValue[item?.id]?.includes(e?.userId)
          );
          item['newValue'] = formValue?.[item?.id];

          formValue?.[item?.id]
            ?.filter((e) => e && !oldUserID?.includes(e))
            ?.map(async (item) => {
              await RESTNotification('createGammasAndContributors', item, id);
            });
        } else {
          if (formValue[item?.id] !== undefined) {
            item['newValue'] = formValue[item?.id];
          } else {
            item['newValue'] = []; // Set it to an empty array when formValue[item?.id] is undefined
          }
        }
      } else {
        if (
          item?.inputType === 'multiLine' &&
          item?.id !== process.env.REACT_APP_DESCRIPTION_ID
        ) {
          if (formValue[item?.id] !== undefined) {
            item['newValue'] = [formValue[item?.id]];
          } else {
            item['newValue'] = []; // Set it to an empty array when formValue[item?.id] is undefined
          }
        } else if (
          item?.inputType === 'singleLine' &&
          item?.id !== process.env.REACT_APP_TITLE_ID
        ) {
          if (formValue[item?.id] !== undefined) {
            item['newValue'] = [formValue[item?.id]];
          } else {
            item['newValue'] = [];
          }
        } else if (item?.inputType === 'link') {
          if (item?.value) {
            const oldValue = attachedLinks.map((item) => item?.text);
            const newValue = attachment;
            const mergedValue = oldValue.concat(newValue);
            item['newValue'] = mergedValue;
          } else {
            item['newValue'] = attachment;
          }
        } else if (item?.inputType === 'dragger') {
          const uploadFilePromises = createFile?.map(async (el) => {
            const uplaodFile = await uploadFileToS3(el?.originFileObj);
            return uplaodFile;
          });

          uploadPromises.push(...uploadFilePromises);
        } else if (item?.id === process.env.REACT_APP_SPONSOR_ID) {
          if (formValue[item?.id] !== undefined) {
            item['newValue'] = { id: formValue?.[item?.id] };
          } else {
            item['newValue'] = [];
          }
          if (formValue?.[item?.id] !== item?.value?.id) {
            await RESTNotification('updateSponsor', formValue?.[item?.id], id);
          }
        } else if (item?.inputType === 'datepicker') {
          if (formValue[item?.id] !== undefined) {
            item['newValue'] = [date];
          } else {
            item['newValue'] = [];
          }
        } else if (item?.type === 'measurement') {
          for (const id in scaleValue) {
            const itemToUpdate = formLayoutByGamma.layout.find(
              (item) => item.id === id
            );
            if (itemToUpdate) {
              itemToUpdate.newValue = scaleValue[id];
            }
          }
        } else {
          if (
            item?.dropdownValue === 'Single' &&
            item?.id !== process.env.REACT_APP_SPONSOR_ID
          ) {
            if (formValue[item?.id] !== undefined) {
              item['newValue'] = Array.isArray(formValue[item?.id])
                ? formValue[item?.id]
                : [formValue[item?.id]];
            } else {
              item['newValue'] = [];
            }
          } else {
            item['newValue'] = formValue[item?.id];
          }
        }
      }
    });

    const uploadResults = await Promise.all(uploadPromises);
    const objectiveData = uploadResults.map((item) => item?.key);
    formLayoutByGamma?.layout?.forEach((item) => {
      if (item?.inputType === 'dragger') {
        item['newValue'] = [...fileUpload, ...objectiveData];
      }
    });

    await RESTSubmitform({ ...formLayoutByGamma });
    setLoader(false);
    await fetchGammaDetails();
    setAttachMent([]);
    message.success('Items updated successfully');
    setShowView(true);
    setFormChanges(false);
  };
  let editPage = window.location.pathname.includes('edit');

  let mappedData = [];

  formLayoutByGamma?.layout?.forEach((layoutItem) => {
    formLayoutByGamma?.level?.measurementFieldConnection?.items?.forEach(
      (connectionItem) => {
        if (layoutItem?.id === connectionItem?.measurementField?.id) {
          mappedData.push({
            ...layoutItem,
            ...connectionItem,
          });
        }
      }
    );
  });

  const ids = formLayoutByGamma?.layout?.map((item) => item?.id);
  const filteredData =
    formLayoutByGamma?.level?.measurementFieldConnection?.items?.filter(
      (item) => ids?.includes(item?.measurementField?.id)
    );

  const scaleOnChangeData = mappedData?.map((item) => item?.measurementField);

  const [sliderColor, SetSliderColor] = useState({});

  const onChange = (value, id) => {
    let adjustedValue = value;
    if (scaleOnChangeData?.find((item) => item.id === id)?.subType === '-+') {
      adjustedValue = (value / 100) * 4 - 2;
    } else if (
      scaleOnChangeData?.find((item) => item.id === id)?.subType === '+-'
    ) {
      adjustedValue = 2 - (value / 100) * 4;
    }
    setScaleValue((prevValues) => ({
      ...prevValues,
      [id]: adjustedValue,
    }));
    SetSliderColor({ ...sliderColor, [id]: adjustedValue });
  };

  const handleNumericChange = (value, id) => {
    let adjustedValue = value;
    setScaleValue((prevValues) => ({
      ...prevValues,
      [id]: adjustedValue,
    }));
  };

  const sliders = mappedData?.map((item, index) => {
    if (!item?.hide) {
      const marks = {};
      if (
        item?.measurementField?.subType === '-+' ||
        item?.measurementField?.subType === '+-'
      ) {
        item?.measurementField?.breakpoints.forEach((breakpoint, index) => {
          marks[index * 25] = breakpoint.label;
        });

        let value = 0;
        if (item?.measurementField?.subType === '-+') {
          value = ((scaleValue[item.id] + 2) * 100) / 4;
        } else if (item?.measurementField?.subType === '+-') {
          value = -(((scaleValue[item.id] - 2) * 100) / 4);
        }

        return (
          <>
            <Typography.Text>{item?.measurementField?.name}</Typography.Text>
            <Col span={24} key={index} className="ranking-scale-slider">
              <Slider
                className={
                  item?.measurementField?.subType === '+-'
                    ? `opportunity-slider opportunity-slider-${index} slider-change-1 m-0`
                    : `opportunity-slider slider-change m-0 opportunity-slider-${index}`
                }
                tooltip={{ open: false }}
                onChange={(value) => onChange(value, item.id)}
                marks={marks}
                value={value || 50}
              />
            </Col>
          </>
        );
      } else {
        return null;
      }
    }
  });

  useEffect(() => {
    // eslint-disable-next-line

    mappedData.map((item, index) => {
      const Slider = document.querySelector(`.opportunity-slider-${index}`);
      const SliderStyles = Slider?.style;

      let value = 0;
      if (item?.measurementField?.subType === '-+') {
        value = Math.ceil(((scaleValue[item.id] + 2) * 100) / 4);
      } else if (item?.measurementField?.subType === '+-') {
        value = Math.ceil(-(((scaleValue[item.id] - 2) * 100) / 4));
      }

      if (item?.measurementField?.subType === '-+') {
        if (value >= 0 && value < 20) {
          SliderStyles?.setProperty(
            '--OuterDotColor',
            `linear-gradient(180deg, #FC5957 0%, #F93432 100%)`
          );
          SliderStyles?.setProperty(
            '--InnerDotColor',
            `linear-gradient(180deg, #C60807 0%, #ED2623 22.67%, #FF7171 100%)`
          );
        } else if (value >= 20 && value < 40) {
          SliderStyles?.setProperty(
            '--OuterDotColor',
            `linear-gradient(180deg, #FFAD58 0%, #FA8B14 100%)`
          );
          SliderStyles?.setProperty(
            '--InnerDotColor',
            `linear-gradient(180deg, #E48632 0%, #E48632 22.67%, #FEBA71 100%)`
          );
        } else if (value >= 40 && value < 60) {
          SliderStyles?.setProperty(
            '--OuterDotColor',
            `linear-gradient(180deg, #CDCDCD 0%, #858484 100%)`
          );
          SliderStyles?.setProperty(
            '--InnerDotColor',
            `linear-gradient(180deg, #838383 0%, #9A9A9A 22.67%, #C2C2C2 100%)`
          );
        } else if (value >= 60 && value < 80) {
          SliderStyles?.setProperty(
            '--OuterDotColor',
            `linear-gradient(180deg, #7CBF66 0%, #55B04E 100%)`
          );
          SliderStyles?.setProperty(
            '--InnerDotColor',
            `linear-gradient(180deg, #379225 0%, #3DA628 22.67%, #9ACF8F 100%)`
          );
        } else if (value >= 80 && value < 100) {
          SliderStyles?.setProperty(
            '--OuterDotColor',
            `linear-gradient(180deg, #17D971 0%, #0F7D42 100%)`
          );
          SliderStyles?.setProperty(
            '--InnerDotColor',
            `linear-gradient(180deg, #089348 0%, #0E9D51 22.67%, #2CD279 100%)`
          );
        }
      } else {
        if (value >= 0 && value < 20) {
          SliderStyles?.setProperty(
            '--OuterDotColor',
            `linear-gradient(180deg, #17D971 0%, #0F7D42 100%)`
          );
          SliderStyles?.setProperty(
            '--InnerDotColor',
            `linear-gradient(180deg, #089348 0%, #0E9D51 22.67%, #2CD279 100%)`
          );
        } else if (value >= 20 && value < 40) {
          SliderStyles?.setProperty(
            '--OuterDotColor',
            `linear-gradient(180deg, #7CBF66 0%, #55B04E 100%)`
          );
          SliderStyles?.setProperty(
            '--InnerDotColor',
            `linear-gradient(180deg, #379225 0%, #3DA628 22.67%, #9ACF8F 100%)`
          );
        } else if (value >= 40 && value < 60) {
          SliderStyles?.setProperty(
            '--OuterDotColor',
            `linear-gradient(180deg, #CDCDCD 0%, #858484 100%)`
          );
          SliderStyles?.setProperty(
            '--InnerDotColor',
            `linear-gradient(180deg, #838383 0%, #9A9A9A 22.67%, #C2C2C2 100%)`
          );
        } else if (value >= 60 && value < 80) {
          SliderStyles?.setProperty(
            '--OuterDotColor',
            `linear-gradient(180deg, #FFAD58 0%, #FA8B14 100%)`
          );
          SliderStyles?.setProperty(
            '--InnerDotColor',
            `linear-gradient(180deg, #E48632 0%, #E48632 22.67%, #FEBA71 100%)`
          );
        } else if (value >= 80 && value < 100) {
          SliderStyles?.setProperty(
            '--OuterDotColor',
            `linear-gradient(180deg, #FC5957 0%, #F93432 100%)`
          );
          SliderStyles?.setProperty(
            '--InnerDotColor',
            `linear-gradient(180deg, #C60807 0%, #ED2623 22.67%, #FF7171 100%)`
          );
        }
      }
    });
    // eslint-disable-next-line
  }, [mappedData, sliderColor]);

  const numericSlider = mappedData.map((item, index) => {
    if (!item?.hide) {
      if (
        item?.measurementField?.subType === '$' ||
        item?.measurementField?.subType === '#'
      ) {
        const numericMarks = (low, high) => {
          const interval = high && low ? (high - low) / 4 : 25;
          const marks = {};
          if (isNaN(low) && isNaN(high)) {
            marks[0] = 'Low End';
            marks[100] = 'High End';
          }
          if (low === undefined || isNaN(low)) {
            marks[0] = 'Low End';
          } else {
            marks[low] = low;
          }

          if (high === undefined || high === 0 || isNaN(high)) {
            marks[100] = 'High End';
          } else {
            marks[high] = high;
          }

          for (let i = 1; i <= 3; i++) {
            marks[low + interval * i] = `Point ${i}`;
          }
          return marks;
        };

        const lowValue = item?.measurementField?.breakpoints[0].value;
        const highValue = item?.measurementField?.breakpoints[1].value;
        const marks = numericMarks(lowValue, highValue);

        const convertValueToSliderRange = (value, maxValue) => {
          return Math.max(0, Math.min(100, (value * 100) / maxValue));
        };

        // Usage:
        const newValueFromBackend = scaleValue[item?.id]; // Example value received from the backend
        const maxValue = highValue; // Example maximum value

        const sliderValue = convertValueToSliderRange(
          newValueFromBackend,
          maxValue
        );

        return (
          <>
            <Typography.Text>{item?.measurementField?.name}</Typography.Text>
            <Col className="ranking-slider" span={24}>
              <Slider
                tooltip={{ open: true }}
                className="numeric-slider"
                tipFormatter={(value) => {
                  const prefix =
                    item?.measurementField?.subType === '$' ? '$' : '#';
                  return `${prefix}${value}`;
                }}
                marks={marks}
                min={lowValue}
                max={highValue}
                value={scaleValue[item?.id]}
                onChange={(value) => handleNumericChange(value, item?.id)}
              />
            </Col>
          </>
        );
      }
    }
  });

  return (
    <Form
      onFieldsChange={handleFormLeave}
      onFinish={updateFormItems}
      form={form}
      layout="vertical"
      className={
        !editPage
          ? ' mt-20 opportunity-form opportunity-detail-edit'
          : 'mt-20 opportunity-form'
      }
    >
      <Row gutter={20}>
        {formLayoutByGamma?.layout?.map((item) => {
          return (
            <>
              {item.inputType === 'singleLine' && !item?.hide && (
                <Col span={12} md={12} sm={24} xs={24}>
                  <Form.Item
                    name={item.id}
                    label={
                      <Row>
                        <Typography.Title level={5} className="mb-0 fs-14">
                          {item.label}
                        </Typography.Title>
                        {item.tooltip && (
                          <Tooltip title={item.tooltip}>
                            <InfoCircleOutlined className="tooltip-icon ml-5" />
                          </Tooltip>
                        )}
                      </Row>
                    }
                    rules={[
                      {
                        required: item.required,
                        message: 'Please Enter Title!',
                      },
                    ]}
                  >
                    <Input className="fs-14" placeholder={item.placeholder} />
                  </Form.Item>
                </Col>
              )}
              {item.inputType === 'multiLine' &&
                !item?.hide &&
                (item.id === process.env.REACT_APP_DESCRIPTION_ID ? (
                  <Col span={24} md={24} sm={24} xs={24}>
                    <Form.Item
                      name={item.id}
                      label={
                        <Row>
                          <Typography.Title level={5} className="mb-0 fs-14">
                            {item.label}
                          </Typography.Title>
                          {item.tooltip && (
                            <Tooltip title={item.tooltip}>
                              <InfoCircleOutlined className="tooltip-icon ml-5" />
                            </Tooltip>
                          )}
                        </Row>
                      }
                      rules={[
                        {
                          required: item.required,
                          message: 'Please Enter Title!',
                        },
                      ]}
                    >
                      <TextArea
                        autoSize={{
                          minRows: 5,
                          maxRows: 5,
                        }}
                        className="fs-14"
                        placeholder={item.placeholder}
                        value={item?.value}
                        maxLength={item?.maxChars}
                      />
                    </Form.Item>
                  </Col>
                ) : (
                  <Col span={12} md={12} sm={24} xs={24}>
                    <Form.Item
                      name={item.id}
                      rules={[
                        {
                          required: item.required,
                          message: `Please input ${item?.label}!`,
                        },
                      ]}
                      label={
                        <Row>
                          <Typography.Title level={5} className="mb-0 fs-14">
                            {item.label}
                          </Typography.Title>
                          {item?.maxChars !== '' &&
                            item?.maxChars !== undefined && (
                              <span className="text-gray">
                                (Max. {item?.maxChars} limit)
                              </span>
                            )}
                          {item.tooltip && (
                            <Tooltip title={item.tooltip}>
                              <InfoCircleOutlined className="tooltip-icon ml-5" />
                            </Tooltip>
                          )}
                        </Row>
                      }
                    >
                      <TextArea
                        autoSize={{
                          minRows: 5,
                          maxRows: 5,
                        }}
                        maxLength={item?.maxChars}
                        className="fs-14"
                        placeholder={item.placeholder}
                      />
                    </Form.Item>
                  </Col>
                ))}

              {item.inputType === 'dropdown' && !item?.hide && (
                <Col span={12} md={12} sm={24} xs={24}>
                  <Form.Item
                    name={item.id}
                    label={
                      <Row>
                        <Typography.Title level={5} className="mb-0 fs-14">
                          {item.label}
                        </Typography.Title>
                        {item.tooltip && (
                          <Tooltip title={item.tooltip}>
                            <InfoCircleOutlined className="tooltip-icon ml-5" />
                          </Tooltip>
                        )}
                      </Row>
                    }
                    rules={[
                      {
                        required: item.required,
                        message: `Please input ${item?.label}!`,
                      },
                    ]}
                  >
                    <Select
                      className={
                        item?.dropdownValue === 'Multiple'
                          ? 'dropdown-style'
                          : ''
                      }
                      placeholder={item.placeholder}
                      mode={
                        item?.dropdownValue === 'Multiple'
                          ? 'multiple'
                          : 'single'
                      }
                    >
                      {item?.optionType === 'Custom' &&
                        item?.custom_values?.map((item, index) => {
                          return (
                            <Option value={item} key={index}>
                              {item}
                            </Option>
                          );
                        })}
                      {item?.datasetValue?.includes('department') &&
                        listAllDepartments?.map((item, index) => {
                          return (
                            <Option value={item?.id} key={index}>
                              {item?.name}
                            </Option>
                          );
                        })}
                      {item?.datasetValue?.includes('employees') &&
                        userData?.map((item, index) => {
                          return (
                            <Select.Option
                              key={index}
                              value={item?.id}
                              disabled={item?.status === userStatus.disabled}
                            >
                              {item?.status === userStatus.disabled ? (
                                <Tooltip title="Disabled user">
                                  {item?.firstName + ' ' + item?.lastName}
                                </Tooltip>
                              ) : (
                                item?.firstName + ' ' + item?.lastName
                              )}
                            </Select.Option>
                          );
                        })}
                      {item?.datasetValue?.includes('leaders') &&
                        userData
                          ?.filter((item) => item.role === UserRole.leader)
                          ?.map((item, index) => {
                            return (
                              <Select.Option
                                key={index}
                                value={item?.id}
                                disabled={item?.status === userStatus.disabled}
                              >
                                {item?.firstName + ' ' + item?.lastName}
                              </Select.Option>
                            );
                          })}
                      {item?.datasetValue?.includes('admin') &&
                        userData
                          ?.filter((item) => item.role === UserRole.admin)
                          ?.map((item, index) => {
                            return (
                              <Select.Option
                                key={index}
                                value={item?.id}
                                disabled={item?.status === userStatus.disabled}
                              >
                                {item?.firstName + ' ' + item?.lastName}
                              </Select.Option>
                            );
                          })}
                    </Select>
                  </Form.Item>
                </Col>
              )}

              {item?.inputType === 'datepicker' && !item?.hide && (
                <Col span={12} md={12} sm={24} xs={24}>
                  <Form.Item
                    label={
                      <Row>
                        <span className="fs-14">{item?.label}</span>
                        {item.tooltip && (
                          <Tooltip title={item.tooltip}>
                            <InfoCircleOutlined className="tooltip-icon ml-5" />
                          </Tooltip>
                        )}
                      </Row>
                    }
                    rules={[
                      {
                        required: item?.required,
                        message: `Please Enter ${item?.label}`,
                      },
                    ]}
                    name={item?.id}
                  >
                    <DatePicker
                      className="w-100"
                      placeholder={item?.placeholder}
                      format="YYYY-MM-DD"
                      onChange={handleChangeDate}
                    />
                  </Form.Item>
                </Col>
              )}
              {item.inputType === 'related items' && !item?.hide && (
                <Col span={24} md={24} sm={24} xs={24}>
                  <div className="details mb-20 mt-0 fs-14">
                    <Typography.Title level={5} className="title">
                      Please link any other items you believe are related to
                      this one.{' '}
                    </Typography.Title>
                    <Button
                      type="primary"
                      className="orange-btn fw-bold mt-20"
                      onClick={showDrawer}
                      size="middle"
                    >
                      Add Related Items
                    </Button>
                  </div>
                  <Row
                    className="idea related-item mt-20 mb-20"
                    gutter={[20, 20]}
                  >
                    {relatedIdea?.map((item) => {
                      return (
                        <Col
                          span={12}
                          md={12}
                          sm={24}
                          xs={24}
                          key={item?.linkedGamma?.title}
                        >
                          <div className="idea-box idea">
                            <div className="h-100 wrapper">
                              <Row>
                                <Link>
                                  <Paragraph
                                    className="title fs-20"
                                    ellipsis={{
                                      rows: 2,
                                      expandable: false,
                                      symbol: 'more',
                                      tooltip: item?.linkedGamma?.title,
                                    }}
                                  >
                                    {item?.linkedGamma?.title}
                                  </Paragraph>

                                  <Paragraph
                                    className="idea-desc fs-16"
                                    ellipsis={{
                                      rows: 3,
                                      expandable: false,
                                      symbol: 'more',
                                      tooltip: item?.linkedGamma?.description,
                                    }}
                                  >
                                    {item?.linkedGamma?.description}
                                  </Paragraph>
                                </Link>
                              </Row>

                              <Row
                                align="middle"
                                justify="space-between"
                                className="w-100"
                              >
                                <Divider />
                                <Row align="middle">
                                  <Typography.Title
                                    level={5}
                                    className="mb-0 fs-14"
                                  >
                                    <span>ID : </span>{' '}
                                    <span
                                      style={{
                                        fontWeight: '700',
                                      }}
                                    >
                                      {item?.linkedGamma?.friendlyId &&
                                        item?.linkedGamma?.friendlyId
                                          .toString()
                                          .padStart(6, '0')}
                                    </span>{' '}
                                  </Typography.Title>
                                  <Typography.Title className="mt-0 mb-0 ml-10 fs-14">
                                    <span className="fw-400">Type : </span>{' '}
                                    <Tag
                                      className="fs-14"
                                      key={item?.linkedGamma?.level?.id}
                                      color={
                                        levelColors[
                                          item?.linkedGamma?.level?.level
                                        ]
                                      }
                                    >
                                      {item?.linkedGamma?.level?.name}
                                    </Tag>
                                  </Typography.Title>
                                </Row>

                                <Popover
                                  content={'Idea link copied'}
                                  placement="bottom"
                                  trigger="clicked"
                                >
                                  <Button
                                    className="unlink-btn"
                                    onClick={() => unLinkIdeas(item?.id)}
                                    size="middle"
                                  >
                                    Unlink
                                  </Button>
                                </Popover>
                              </Row>
                            </div>
                          </div>
                        </Col>
                      );
                    })}
                  </Row>
                </Col>
              )}

              {item.inputType === 'dragger' && !item?.hide && (
                <>
                  <Col span={24} md={24} sm={24} xs={24}>
                    <Row className="upload-area mb-20 mt-0">
                      <Col span={24} className="mb-20">
                        <Typography.Title level={5} className="fs-14">
                          Upload files
                        </Typography.Title>
                        <Dragger maxCount={5} {...props}>
                          <p className="ant-upload-drag-icon">
                            <UploadOutlined />
                          </p>
                          <p className="ant-upload-text">
                            Drag and drop files, or{' '}
                            <span className="text-primary">Browse</span>
                          </p>
                          <p className="ant-upload-hint">
                            Supported format: Word, Excel, PPT, Google Sheets
                            with max size of 5 MB. Max 5 files can be upload
                          </p>
                        </Dragger>
                      </Col>
                    </Row>
                  </Col>
                  {fileUpload?.length > 0 && (
                    <Col span={24}>
                      <Typography.Title level={5}>
                        Uploaded files
                      </Typography.Title>
                      <Row
                        justify="space-between"
                        align="middle"
                        className="attach-link mb-10"
                      >
                        <Col span={24}>
                          {fileUpload.map((item, index) => {
                            return (
                              <>
                                <Row
                                  justify="space-between"
                                  align="middle"
                                  className="link-added mb-10"
                                  key={item}
                                >
                                  <Paragraph
                                    ellipsis
                                    className="mb-0 fs-14 text-primary"
                                  >
                                    {item}
                                  </Paragraph>
                                  <Button
                                    type="text"
                                    onClick={() =>
                                      deleteUploadedFiles(item, index)
                                    }
                                    size="middle"
                                  >
                                    Remove
                                  </Button>
                                </Row>
                              </>
                            );
                          })}
                        </Col>
                      </Row>
                    </Col>
                  )}
                </>
              )}
              {item.inputType === 'link' && !item?.hide && (
                <Col span={24} md={24} sm={24} xs={24}>
                  <Row className="upload-area mb-20 mt-0">
                    <Col span={24}>
                      <Row className="mt-20 attach-link" gutter={[10, 10]}>
                        <Col span={21} lg={21} md={20} xs={24} sm={24}>
                          <Form.Item
                            label={<span className="fs-14">Attach a link</span>}
                          >
                            <Input
                              placeholder="Paste document link here"
                              value={insertLink}
                              onChange={(e) => setInsertLink(e.target.value)}
                            />
                          </Form.Item>
                        </Col>
                        <Col span={3} lg={3} md={4} xs={24} sm={24}>
                          <Form.Item label="" className="mb-0">
                            <Button
                              type="primary"
                              className="blue-filled-btn "
                              size="middle"
                              // className="primary-btn w-100"
                              onClick={() => {
                                if (insertLink) {
                                  setAttachMent([...attachment, insertLink]);
                                  setInsertLink('');
                                }
                              }}
                            >
                              Attach
                            </Button>
                          </Form.Item>
                        </Col>
                        {(attachedLinks?.length > 0 ||
                          attachment?.length > 0) && (
                          <Col span={24}>
                            <Typography.Title level={5} className="p">
                              Attached link{' '}
                            </Typography.Title>

                            {attachedLinks
                              .concat(attachment)
                              .map((item, index) => {
                                return (
                                  <Row
                                    justify="space-between"
                                    align="middle"
                                    className="link-added mb-10"
                                    key={index}
                                  >
                                    <a
                                      href={item?.url || item?.text || item}
                                      className="mb-0 fs-14 text-primary"
                                    >
                                      {item?.url || item?.text || item}
                                    </a>
                                    <Button
                                      type="text"
                                      onClick={() =>
                                        deleteAttachLinks(item, index)
                                      }
                                      size="middle"
                                    >
                                      Remove
                                    </Button>
                                  </Row>
                                );
                              })}
                          </Col>
                        )}
                      </Row>
                    </Col>
                  </Row>
                </Col>
              )}
            </>
          );
        })}
        {sliders}
        {numericSlider}
      </Row>
      <Form.Item>
        <Button
          type="primary"
          htmlType="submit"
          className="blue-filled-btn mr-10"
          size="middle"
          // className="primary-btn save-btn mr-10"
          loading={loader}
        >
          Save
        </Button>
        <Button
          htmlType="submit"
          onClick={() => {
            setShowView(true);
          }}
          size="middle"
        >
          Cancel
        </Button>
      </Form.Item>
    </Form>
  );
};

export default ItemDetailPage;

